/* Toggle .is-scrolled on the header for glassmorphism pill transition */
(function initHeaderScroll() {
  const header = document.querySelector('store-header.header');
  if (!header) return;

  const threshold = 50;
  let ticking = false;

  function update() {
    if (window.scrollY > threshold) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  update();
})();

/* ── Title + Price inline row ──
 * Wraps the title and price block-items in a flex row so
 * price sits right-aligned on the same line as the title.
 */
(function initTitlePriceRow() {
  var titleBlock = document.querySelector('.product-info .product-info__block-item[data-block-type="title"]');
  var priceBlock = document.querySelector('.product-info .product-info__block-item[data-block-type="price"]');

  if (!titleBlock || !priceBlock) return;
  if (titleBlock.parentNode !== priceBlock.parentNode) return;

  var wrapper = document.createElement('div');
  wrapper.className = 'ss-title-price-row';
  titleBlock.parentNode.insertBefore(wrapper, titleBlock);
  wrapper.appendChild(titleBlock);
  wrapper.appendChild(priceBlock);
})();

/* ── Two-button buy flow ──
 * "Buy & Save Now" (copper) → native form POST to /cart/add + server redirect to /checkout
 * "Add to Cart" (outline) → AJAX add (Impact default) + cart drawer
 *
 * The primary button uses a hidden native <form> that POSTs directly to
 * Shopify's /cart/add endpoint with return_to=/checkout. This skips all
 * AJAX, all JS event chains, and lets the server handle the redirect.
 * Result: one click, one request, instant checkout page.
 */
(function initBuyButtons() {
  function setupButtons() {
    var buyContainers = document.querySelectorAll('.product-info__buy-buttons buy-buttons');
    buyContainers.forEach(function(container) {
      var originalBtn = container.querySelector('[type="submit"]');
      if (!originalBtn || container.dataset.ssSetup === 'true') return;

      var form = originalBtn.closest('form');
      if (!form) return;

      /* Get the variant ID input */
      var variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) return;

      /* Create hidden native form for direct checkout */
      var checkoutForm = document.createElement('form');
      checkoutForm.method = 'POST';
      checkoutForm.action = '/cart/add';
      checkoutForm.style.display = 'none';

      var idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      idInput.value = variantInput.value;

      var sellingPlanInput = document.createElement('input');
      sellingPlanInput.type = 'hidden';
      sellingPlanInput.name = 'selling_plan';
      sellingPlanInput.value = '';

      var returnInput = document.createElement('input');
      returnInput.type = 'hidden';
      returnInput.name = 'return_to';
      returnInput.value = '/checkout';

      checkoutForm.appendChild(idInput);
      checkoutForm.appendChild(sellingPlanInput);
      checkoutForm.appendChild(returnInput);
      document.body.appendChild(checkoutForm);

      /* No proactive id-sync — both click handlers below read variantInput.value
       * at click time (after Impact's variant picker has updated it). The old
       * Object.defineProperty wrapper here was the actual root cause of the
       * variant-change-kills-buttons bug: it omitted configurable:true, so the
       * own property became non-configurable on first setup. On every variant
       * change setupButtons re-runs, hits this line again, and TypeError
       * ("Cannot redefine property") aborts setup before the custom buttons
       * are inserted — and the original submit is hidden by CSS, so the user
       * saw empty space. The MutationObserver on the input attribute was also
       * redundant: programmatic .value sets don't change the HTML attribute. */

      /* Hide original submit button */
      originalBtn.style.display = 'none';

      /* Create "Buy & Save Now" — native form POST to checkout */
      var buyNowBtn = document.createElement('button');
      buyNowBtn.type = 'button';
      buyNowBtn.className = 'ss-buy-now-primary';
      buyNowBtn.textContent = 'Buy & Save Now';
      buyNowBtn.addEventListener('click', function() {
        idInput.value = variantInput.value;

        /* Pick up the selected selling plan from Seal Subscriptions widget */
        var sellingPlanEl = form.querySelector('input[name="selling_plan"]:checked')
          || form.querySelector('input[name="selling_plan"][type="hidden"]')
          || form.querySelector('select[name="selling_plan"]');

        /* Also check Seal's own container for the active plan */
        if (!sellingPlanEl || !sellingPlanEl.value) {
          var sealActive = document.querySelector('.sls-option-container.sls-selected input[name="selling_plan"]')
            || document.querySelector('.sls-option-container.sls-active input[name="selling_plan"]')
            || document.querySelector('.sealsubs-container input[name="selling_plan"]');
          if (sealActive) sellingPlanEl = sealActive;
        }

        sellingPlanInput.value = (sellingPlanEl && sellingPlanEl.value) ? sellingPlanEl.value : '';

        /* If no selling plan is empty string, Shopify treats it as one-time purchase */
        checkoutForm.submit();
      });

      /* Create "Add to Cart" — clicks hidden original (AJAX + cart drawer) */
      var atcBtn = document.createElement('button');
      atcBtn.type = 'button';
      atcBtn.className = 'ss-atc-secondary';
      atcBtn.textContent = 'Add to Cart';
      atcBtn.addEventListener('click', function() {
        originalBtn.style.display = '';
        originalBtn.click();
        originalBtn.style.display = 'none';
      });

      /* Insert both buttons */
      originalBtn.parentNode.insertBefore(buyNowBtn, originalBtn);
      originalBtn.parentNode.insertBefore(atcBtn, originalBtn);

      container.dataset.ssSetup = 'true';
    });
  }

  setTimeout(setupButtons, 300);
  setTimeout(setupButtons, 1000);

  /* The <product-rerender id="product-info-…"> host is stable across variant
   * changes — only its inner DOM is replaced. Observing .product-info__buy-buttons
   * directly leaves us watching a detached node after the first variant click,
   * which is why the custom buttons never reappeared. */
  var infoRerender = document.querySelector('product-rerender[id^="product-info-"]');
  if (infoRerender) {
    new MutationObserver(function() { setTimeout(setupButtons, 50); }).observe(infoRerender, { childList: true, subtree: true });
  }
  document.addEventListener('variant:change', function() { setTimeout(setupButtons, 50); });

  /* ── Sticky bar: hijack the existing button — change text + behavior to direct checkout ── */
  function setupStickyBar() {
    var stickyBuyContainers = document.querySelectorAll('.product-quick-add buy-buttons');
    stickyBuyContainers.forEach(function(container) {
      if (container.dataset.ssStickySetup === 'true') return;

      var originalBtn = container.querySelector('[type="submit"]');
      if (!originalBtn) return;

      var form = document.querySelector('form[id^="product-form"]');
      var variantInput = form ? form.querySelector('input[name="id"]') : null;
      if (!variantInput) return;

      /* Change the button text */
      var textEl = originalBtn.querySelector('.button__content, span') || originalBtn;
      textEl.textContent = 'Buy & Save Now';

      /* Intercept click — direct to checkout instead of AJAX add */
      originalBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var stickyForm = document.createElement('form');
        stickyForm.method = 'POST';
        stickyForm.action = '/cart/add';
        stickyForm.style.display = 'none';

        var idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'id';
        idInput.value = variantInput.value;

        var sellingPlanInput = document.createElement('input');
        sellingPlanInput.type = 'hidden';
        sellingPlanInput.name = 'selling_plan';

        var sellingPlanEl = form.querySelector('input[name="selling_plan"]:checked')
          || form.querySelector('input[name="selling_plan"][type="hidden"]')
          || document.querySelector('.sls-option-container.sls-selected input[name="selling_plan"]')
          || document.querySelector('.sls-option-container.sls-active input[name="selling_plan"]')
          || document.querySelector('.sealsubs-container input[name="selling_plan"]');
        sellingPlanInput.value = (sellingPlanEl && sellingPlanEl.value) ? sellingPlanEl.value : '';

        var returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        returnInput.value = '/checkout';

        stickyForm.appendChild(idInput);
        stickyForm.appendChild(sellingPlanInput);
        stickyForm.appendChild(returnInput);
        document.body.appendChild(stickyForm);
        stickyForm.submit();
      }, true);

      container.dataset.ssStickySetup = 'true';
    });
  }

  setTimeout(setupStickyBar, 500);
  setTimeout(setupStickyBar, 1500);

  /* Same fix as the main buy-buttons: observe the stable <product-rerender id="…-sticky-bar">
   * host instead of its replaceable .product-quick-add child. */
  var stickyRerender = document.querySelector('product-rerender[id$="-sticky-bar"]');
  if (stickyRerender) {
    new MutationObserver(function() { setTimeout(setupStickyBar, 50); }).observe(stickyRerender, { childList: true, subtree: true });
  }
  document.addEventListener('variant:change', function() { setTimeout(setupStickyBar, 50); });
})();

/* ── Click anywhere on grid image to open lightbox ── */
(function initGridImageZoom() {
  document.querySelectorAll('.product-gallery--desktop-grid .product-gallery__media[data-media-type="image"]').forEach(function(media) {
    media.addEventListener('click', function(e) {
      /* Don't double-fire if they clicked the zoom button itself */
      if (e.target.closest('button[is="product-zoom-button"]')) return;

      var zoomBtn = media.querySelector('button[is="product-zoom-button"]');
      if (zoomBtn) {
        zoomBtn.click();
      }
    });
  });
})();

/* ── Judge.me: show "Read more" only when review is truncated ──
 * Judge.me renders the read-more link on every review regardless of length.
 * We hide it by default (CSS) and only show it when the paragraph is
 * actually clamped. Clicking toggles expansion. */
(function initReviewReadMore() {
  function processReviewBody(body) {
    if (body.dataset.ssProcessed === 'true') return;
    var p = body.querySelector('p');
    if (!p) return;

    /* Check if the content is actually truncated by the line-clamp */
    if (p.scrollHeight > p.clientHeight + 1) {
      body.classList.add('is-truncated');
    }

    var btn = body.querySelector('.jdgm-rev__body-read-more');
    if (btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var expanded = body.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Show less' : 'Read more';
      });
    }

    body.dataset.ssProcessed = 'true';
  }

  function scan() {
    document.querySelectorAll('.jdgm-rev__body').forEach(processReviewBody);
  }

  /* Initial scan after Judge.me renders */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(scan, 500); });
  } else {
    setTimeout(scan, 500);
  }

  /* Re-scan when Judge.me injects more reviews (Load More) */
  var observer = new MutationObserver(function() { scan(); });
  observer.observe(document.body, { childList: true, subtree: true });

  /* Re-scan on resize (line-clamp threshold changes with width) */
  var resizeTimer = null;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      document.querySelectorAll('.jdgm-rev__body').forEach(function(body) {
        if (body.classList.contains('is-expanded')) return;
        var p = body.querySelector('p');
        if (!p) return;
        if (p.scrollHeight > p.clientHeight + 1) {
          body.classList.add('is-truncated');
        } else {
          body.classList.remove('is-truncated');
        }
      });
    }, 200);
  });
})();

(function initScrollReveal() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('ss-visible');
        revealObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
  );

  document
    .querySelectorAll(
      '.ss-truth-window, .ss-problem, .ss-products-grid, .ss-how-it-works, .ss-proof-gallery, .ss-comparison, .ss-origin, .ss-faq, .ss-final-cta, .ss-newsletter'
    )
    .forEach((element) => {
      element.classList.add('ss-reveal');
      revealObserver.observe(element);
    });
})();

/* ── Exclusive accordions in product info ──
 * When one accordion opens inside .product-info .accordion-group,
 * close all siblings. Uses MutationObserver on the "open" attribute
 * so it works with Impact's animated AccordionDisclosure. */
(function initExclusiveAccordions() {
  document.querySelectorAll('.product-info .accordion-group, .product-info [data-group-type="accordion-group"]').forEach(function(group) {
    var accordions = group.querySelectorAll('details.accordion');
    if (accordions.length < 2) return;

    accordions.forEach(function(accordion) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          if (m.attributeName === 'open' && accordion.hasAttribute('open')) {
            accordions.forEach(function(sibling) {
              if (sibling !== accordion && sibling.hasAttribute('open')) {
                sibling.open = false;
              }
            });
          }
        });
      });
      observer.observe(accordion, { attributes: true, attributeFilter: ['open'] });
    });
  });
})();


/* Mobile CTA is now an always-visible floating pill (see .ss-mobile-cta in
 * ss-shell.css). No scroll-reveal observer needed. */

/* ── Judge.me: visually prioritize reviews with images via CSS order ──
 * We avoid programmatic sort (dispatchEvent causes Judge.me to scroll).
 * Instead, use CSS flexbox order to push reviews with images to the top. */
(function initJudgeMeImagePriority() {
  function prioritize() {
    var reviews = document.querySelectorAll('.jdgm-rev');
    if (!reviews.length) return false;

    reviews.forEach(function(rev, i) {
      var hasImage = rev.querySelector('.jdgm-rev__photos, .jdgm-rev__media, .jdgm-rev-photo, img[src*="judgeme"]');
      rev.style.order = hasImage ? '-1' : String(i);
    });

    /* Make the parent flex so order works */
    var container = reviews[0].parentElement;
    if (container) {
      container.style.display = 'flex';
      container.style.flexDirection = 'column';
    }
    return true;
  }

  /* Judge.me loads async — retry until reviews render */
  var attempts = 0;
  var interval = setInterval(function() {
    if (prioritize() || attempts > 30) clearInterval(interval);
    attempts++;
  }, 500);
})();
